import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userRequiresPhoneVerificationBackend } from './user-requires-phone-verification.backend';
import { userRequiresPhoneVerificationReducer } from './user-requires-phone-verification.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userRequiresPhoneVerification',
      userRequiresPhoneVerificationReducer,
    ),
    BackendModule.forFeature(
      'userRequiresPhoneVerification',
      userRequiresPhoneVerificationBackend,
    ),
  ],
})
export class DatastoreUserRequiresPhoneVerificationModule {}
